<template>
  <section class="single-area area-padding mid-top-padding contract-section">
    <div class="service-fluid">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
			<div class="">
				<h3>
					Contrato de Comisión Mercantil Solicitante.
				</h3>
				<p class="bold primary">
					Fecha de actualización: 27 de mayo de 2022
				</p>
			</div>

            <div class="text-justify">

              <strong>CONTRATO DE COMISIÓN MERCANTIL</strong> (en lo sucesivo “<u>Contrato</u>”) que celebran por una parte
              ___________________, por su propio derecho (en lo sucesivo "<u>Comitente</u>"), y por la otra Red Girasol, S.A.P.I. de C.V.,
              representada en este acto por Jorge Armando Cárdenas Tijerina (en lo sucesivo "<u>Comisionista</u>" y en conjunto con
              el Comitente como las “<u>Partes</u>” o individualmente cada uno como una “<u>Parte</u>”); mismo que sujetan al tenor de las
              siguientes Declaraciones y Cláusulas.
              <br>
            <div style="text-align: center"><strong>DECLARACIONES</strong></div>
            <br>

            <ol class="text-justify" style="font-weight:bold">
              <li style="font-size:14px!important"><span style="font-weight:normal">
						Declara el Comisionista a través de su representante legal que: </span><br> <br>
                <ol class="text-justify" style="font-weight:bold">
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Es una sociedad constituida de conformidad con las leyes de los Estados Unidos Mexicanos (“<u>México</u>”)
								según consta en la escritura pública número 49,903 de fecha 14 de abril de 2016 otorgada ante la fe del
								licenciado Eduardo Adolfo Manautou Ayala, titular de la Notaría Pública No. 123 con ejercicio en
								Monterrey, Nuevo León y cuyo primer testimonio quedó inscrito en el registro público de la ciudad de
								Monterrey, Nuevo León bajo el folio mercantil electrónico número 160394*1. Asimismo, declara que
								realiza operaciones de financiamiento colectivo en términos del artículo Octavo Transitorio de la Ley
								FinTech, y se encuentra en proceso de autorización para operar como una Institución de Tecnología
								Financiera según dicho término es definido en el artículo 4º (cuarto) de la Ley FinTech, y que cuenta con
								los recursos y medios necesarios para obtener dicha autorización.
							</span></li><br>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Su representante cuenta con las facultades necesarias y suficientes para suscribir el presente Contrato,
								mismas que se encuentran vigentes y no le han sido revocadas o limitadas en forma alguna a la fecha de
								celebración del presente contrato.
							</span></li><br>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Su objeto social consiste en, entre otros, recibir y publicar las solicitudes de operaciones de
								financiamiento colectivo de deuda de conformidad con el artículo 16 fracción 1 de la Ley FinTech
								(“Operaciones”) de los Solicitantes y sus Proyectos a través del Sitio o medio de comunicación
								electrónica o digital que utilice para realizar sus actividades.
							</span></li><br>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Que: (i) se abstendrá de privilegiar los intereses de algún Cliente sobre otro o actuar con conflictos de
								interés en la ejecución de estos; (ii) mantendrá informados a los Clientes de los actos realizados en la
								ejecución de los mandatos o comisiones de que se trate; y (iii) dará a conocer de forma clara las
								contraprestaciones que, en su caso, se cobrarían por la ejecución del mandato. Para los efectos de esta
								declaración, se entenderá por Cliente tanto a los Inversionistas como a los Solicitantes en los términos del
								artículo 16 de la Ley FinTech.
							</span></li><br>
                </ol>
              </li>
              <li style="font-size:14px!important"><span style="font-weight:normal">
						Declara el Comitente, por su propio derecho o por conducto de su representante declara que: </span><br> <br>
                <ol class="text-justify" style="font-weight:bold">
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Ser una persona física mayor de edad o una sociedad debidamente constituida conforme a las leyes de
								México.
							</span></li><br>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Que él, o en su caso el representante legal, cuenta con las facultades necesarias para celebrar el presente
								contrato según poder que en este acto se tiene a la vista.
							</span></li><br>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Es un usuario registrado del Sitio y reconoce y declara haber revisado, entendido y aceptado sin reserva
								alguna los términos y condiciones, avisos legales y cualesquiera otras cláusulas, declaraciones, derechos
								y/u obligaciones que contiene dicho Sitio.
							</span></li><br>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Reconocer que no se realizará pago alguno al Proveedor para la Instalación de los Productos hasta que el
								Comitente firme los contratos previstos en la Cláusula 3.3 del presente.
							</span></li><br>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Mantiene, a su nombre una cuenta bancaria que podrá ser revelada por el Comisionista a través del Sitio.
							</span></li><br>
                </ol>
              </li>
              <li style="font-size:14px!important"><span style="font-weight:normal">
						Declaran las PARTES que :</span><br> <br>
                <ol class="text-justify" style="font-weight:bold">
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Entienden y conocen la terminología empleada en el presente Contrato, no obstante la utilización de
								tecnicismos propios de la materia que aquí se regula y que son empleados en la determinación de los
								derechos y obligaciones que aquí se pactan.
							</span></li><br>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Se reconocen mutuamente la personalidad y, en su caso, representación con la cual cada una de las Partes
								comparece a la celebración del presente Contrato.</span></li><br>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Están de acuerdo en celebrar el presente Contrato, sujetándolo al tenor de las siguientes cláusulas,
								apéndices, anexos y convenios accesorios que eventualmente se llegaren a celebrar entre las Partes
								incluyendo aquellos que se celebren con o sin la intervención o comparecencia de terceros.
							</span></li><br>
                </ol>
              </li>
            </ol>

            En virtud de lo anterior, las Partes, de común acuerdo, se sujetan a las siguientes:<br>

            <br>
            <div style="text-align: center"><strong>CLÁUSULAS</strong></div>
            <br>

            <ol class="text-justify" style="font-weight:bold">
              <li style="font-size:14px!important"><u>Objeto del Contrato.</u><span style="font-weight:normal">&nbsp;
						Por virtud del presente Contrato, el Comitente otorga y confiere una comisión mercantil al
						Comisionista para prestar en su nombre y representación los Servicios, incluyendo la obtención del Monto especificado
						por el Comitente para el financiamiento del Proyecto por parte de los Inversionistas de manera no exclusiva dentro del
						Territorio, e incluyendo sin limitar las actividades listadas en la Cláusula 3 del presente. <br><br>

						Por este mismo medio, El Comisionista acepta expresamente la comisión mercantil objeto del presente Contrato,
						obligándose con el Comitente a desempeñarla de conformidad con las disposiciones de este Contrato, sin exceder de las
						facultades conferidas en el mismo y sus accesorios.
					</span> </li> <br>
              <li style="font-size:14px!important"><u>Desempeño de la comisión.</u><span style="font-weight:normal">&nbsp;
						El Comisionista, para el desempeño de sus obligaciones, deberá obrar con buena fe y
						realizará sus mejores esfuerzos para el cumplimiento adecuado de la comisión aquí encomendada. El Comisionista deberá
						hacer su mejor esfuerzo por conocer en todo momento las mejores prácticas de promoción del Proyecto en el Sitio. El
						Comitente acepta y reconoce que el Comisionista no realizará ninguna práctica de promoción hasta en tanto el Comitente
						no realice el Pago Inicial en favor del Comisionista.<br><br>

						El Comitente reconoce que el hecho de solicitar los Servicios para el financiamiento del Proyecto para la adquisición de
						los Productos por medio del Sitio no significa que el Productos serán instalados inmediatamente, ya que dicha instalación
						se encuentra sujeta a una condición suspensiva consistente en: (i) el financiamiento del Proyecto por los Inversionistas a
						través del Sitio, cubriendo la totalidad del Monto solicitado y, en caso de obtenerlo, (ii) el Comitente firme los
						Documentos del Crédito.
					</span> </li> <br>
              <li style="font-size:14px!important"><u>Actividades que comprende la comisión.</u><span style="font-weight:normal">&nbsp;
						Durante la vigencia de este Contrato, el Comisionista estará facultado
						para desarrollar las siguientes actividades con el fin de promover los Productos y/o Proyectos con los Inversionistas y/o el
						Comitente:</span> <br> <br>
                <ol class="text-justify" style="font-weight:bold">
                  <li style="font-size:14px!important">Promoción.<span style="font-weight:normal">&nbsp;
								El Comisionista estará facultado para solicitar, de la manera más amplia y a su discreción, a
								los Inversionistas el financiamiento para el financiamiento del Proyecto de una manera comercialmente
								razonable, pudiendo transmitir material promocional e información diversa a los Inversionistas según sea
								necesario para cumplir el objeto de este Contrato. La publicidad y promoción podrá ser efectuada
								mediante todos aquellos medios que el Comisionista considere adecuados para el correcto desarrollo de
								las actividades de promoción.
							</span></li><br>
                  <li style="font-size:14px!important">Entrega de Información.<span style="font-weight:normal">&nbsp;
								El Comisionista estará facultado para entregar toda información a los
								Inversionistas relacionada al Proyecto del Comitente.
							</span></li><br>
                  <li style="font-size:14px!important">Medio de venta.<span style="font-weight:normal">&nbsp;
								El Comisionista a través de su Sitio celebrará los siguientes actos jurídicos para la venta
								de los Productos, sin limitar a: (i) este contrato de comisión mercantil y (ii) los Documentos del Crédito,
								(iii) un contrato de comisión mercantil del Comisionista con el Proveedor, (iii) un contrato de comisión
								del Comisionista con los Inversionistas.
							</span></li><br>
                  <li style="font-size:14px!important">Crédito.<span style="font-weight:normal">&nbsp;
								El Comisionista deberá llevar a cabo las siguientes actividades relacionadas a los Servicios:</span><br><br>
								<ol class="text-justify" style="font-weight:bold">
									<li style="font-size:14px!important">Búsqueda de Inversionistas.<span style="font-weight:normal">&nbsp;
										El Comisionista deberá buscar e identificar Inversionistas para
										financiar el Proyecto del Comitente.
									</span></li><br>
									<li style="font-size:14px!important">Análisis Financiero.<span style="font-weight:normal">&nbsp;
										El Comisionista estará facultado para realizarle al Comitente un análisis de
										crédito y riesgo respecto de las solicitudes de crédito presentadas por el Comitente. Dicha
										información podrá ser publicada por el Comisionista en su Sitio para referencia de los
										Inversionistas.
									</span></li><br>
									<li style="font-size:14px!important">Registro de garantía mobiliaria.<span style="font-weight:normal">&nbsp;
										El Comisionista podrá dar de alta la garantía mobiliaria
										prevista en los Documentos del Crédito en el portal que la Secretaría de Economía establece
										para el registro de garantías mobiliarias (RUG).
									</span></li><br>
									<li style="font-size:14px!important">Pago.<span style="font-weight:normal">&nbsp;
										El Comisionista podrá realizar el pago de la Factura en nombre y representación del
										Comitente en favor del Proveedor una vez que el Proyecto haya sido fondeado exitosamente a
										través del Sitio por los Inversionistas. El pago en nombre del Comitente se realizará una vez que
										el Comitente haya firmado los Documentos del Crédito.
									</span></li><br>
								</ol>
                  </li>
                </ol>
              </li>
              <li style="font-size:14px!important"><u>Actividades excluidas de la comisión.</u><span style="font-weight:normal">&nbsp;
						Se encuentra expresamente excluido dentro de las actividades
						comprendidas en la comisión aquí conferida la elección por parte del Comisionista de empezar con el financiamiento del
						Proyecto para la adquisición de los Productos por parte del Comitente, siendo que dicha elección realiza el Comitente al
						firmar este Contrato y realizar el Pago Inicial, además de otras excepciones previstas en este Contrato.
					</span></li> <br>
              <li style="font-size:14px!important"><u>Contraprestación.</u><span style="font-weight:normal">&nbsp;
						Las Partes acuerdan que el Comisionista percibirá las siguientes contraprestaciones:</span> <br> <br>
                <ol class="text-justify" style="font-weight:bold">
                  <li style="font-size:14px!important">Comisión por Apertura.<span style="font-weight:normal">&nbsp;
								Si el Comitente decide abrir la cuenta en el Sitio para que se financie un
								Proyecto para la adquisición y financiamiento de los Productos por el Comitente, corresponderá al
								Comisionista el 2% (dos por ciento) del valor de la Factura más el correspondiente Impuesto al Valor
								Agregado. Esta comisión será cobrada al Comitente por transferencia electrónica al momento de abrir la
								cuenta en el Sitio y a la firma del presente Contrato. En caso de que el Comitente opte (i) por detener el
								fondeo de su Proyecto colocado en el Sitio o (ii) por no proceder con la adquisición de los Productos una
								vez que el Proyecto hubiese sido exitosamente fondeado o (iii) por no proceder a la firma de los
								Documentos del Crédito, esta comisión no será reembolsada y será considerada como una pena
								convencional.
							</span></li><br>
                  <li style="font-size:14px!important">Comisión por Fondeo.<span style="font-weight:normal">&nbsp;
								Si el Comisionista capta el Monto en favor del Comitente, corresponderá al
								Comisionista el 6% (seis por ciento) del Monto más el correspondiente Impuesto al Valor Agregado. Esta
								comisión será cobrada al ser descontada del Monto una vez que el Comitente firme los Documentos del
								Crédito y el Comisionista realice el pago para la adquisición de los Productos en nombre y por cuenta del
								Comitente.
							</span></li><br>
                  <li style="font-size:14px!important">Comisión por Administración.<span style="font-weight:normal">&nbsp;
								Cuando el Comisionista capte el Monto para la adquisición de los
								Productos en favor del Comitente, corresponderá al Comisionista el 2% (dos por ciento) del valor de la
								Factura por año durante el plazo del Crédito a ser celebrado con los Inversionistas, más el correspondiente
								Impuesto al Valor Agregado. Ésta comisión será cobrada al ser descontada del Monto una vez que el
								Comitente firme los Documentos del Crédito y el Comisionista realice el pago para la adquisición de los
								Productos en nombre y por cuenta del Comitente.</span></li><br>
                </ol>
              </li>
              <li style="font-size:14px!important"><u>Cesión de beneficios ambientales.</u><span style="font-weight:normal">&nbsp;
						Las Partes acuerdan que el Comitente cede gratuitamente al Comisionista los
						beneficios ambientales que pudiesen generar los Productos. Para efectos de claridad, los beneficios ambientales equivalen
						a los kilogramos de dióxido de carbono equivalentes evitados por la generación de energía en razón de los Productos.
					</span></li> <br>
              <li style="font-size:14px!important"><u>Vigencia.</u><span style="font-weight:normal">&nbsp;
						El presente Contrato empezará a surtir sus efectos a partir de la fecha de su firma. El Contrato estará
						vigente hasta en tanto el Crédito sea pagado en su totalidad por el Comitente.
					</span></li> <br>
              <li style="font-size:14px!important"><u>Rescisión.</u><span style="font-weight:normal">&nbsp;
						Las Partes podrán rescindir el presente contrato sin previa declaración judicial, por falta de
						cumplimiento de su contraparte de cualquiera de sus obligaciones derivadas del mismo y en general por los casos de
						incumplimiento que al afecto señalen las disposiciones legales correspondientes, para lo cual bastará que la Parte afectada
						notifique por escrito a la otra con 10 (diez) días naturales de anticipación a la fecha en que deba de surtir efectos la misma.
						La Parte que se encuentra en incumplimiento tendrá 30 (treinta) días naturales para solventar la acción que originó el
						incumplimiento a partir de la notificación de incumplimiento de la contraparte. Además, las Partes convienen en forma
						expresa que las Partes podrán rescindir el presente contrato, sin necesidad de declaración judicial, en caso de que se
						presente alguna de las siguientes circunstancias:</span> <br> <br>
                <ol class="text-justify" style="font-weight:bold">
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Han proporcionado datos falsos al registrarse o al formular el Contrato, o si durante su vigencia y con
								motivo de las obligaciones derivadas del mismo, proporcionare información falsa, errónea, insuficiente, o
								si la información solicitada no se proporcionare o se hiciere en forma extemporánea.
							</span></li><br>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Si se declaran en disolución, liquidación, quiebra o suspensión de pagos.
							</span></li><br>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Si son emplazados a huelga, o existe amenaza de que se inicie el procedimiento correspondiente.
							</span></li><br>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Si incumplen, cumplen en forma parcial, suspenden, o de cualquier forma prestan las actividades aquí
								establecidas de manera irregular, deficiente, negligente o irresponsable; o bien por violar o incumplir
								cualquiera de las obligaciones a su cargo, con motivo o derivadas del presente contrato.
							</span></li><br>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Si el Comitente no firma los Documentos del Crédito dentro de un plazo de 10 días hábiles a partir de que
								el Comisionista obtenga el Monto por parte de los Inversionistas.
							</span></li><br>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Si el Comitente obtiene otro financiamiento a través de una institución de financiamiento colectivo,
								en términos de la Ley FinTech.
							</span></li><br>
                </ol>
              </li>

              <li style="font-size:14px!important"><u>Efectos de la Terminación.</u><span style="font-weight:normal">&nbsp;
						Con excepción de lo establecido en las cláusulas 7 y 8, una vez terminado el presente
						Contrato, los derechos y obligaciones de las Partes terminarán. Las Partes acuerdan que, en caso de que el Contrato se
						rescinda en virtud de las cláusulas 8.4 y 8.5 anteriores, el Comisionista podrá retener como pena convencional la Comisión por
						Apertura.
					</span></li> <br>

              <li class="dosdigitos" style="font-size:14px!important"><u>Relación entre las Partes.</u><span style="font-weight:normal">&nbsp;
						Queda expresamente convenido que de ninguna manera el presente contrato deberá o
						podrá ser considerado o interpretado para crear una coinversión, sociedad, representación, asociación, asociación en
						participación o relación de agencia entre las Partes para ningún propósito. </span></li> <br>

              <li class="dosdigitos" style="font-size:14px!important"><u>No competencia.</u><span style="font-weight:normal">&nbsp;
						Desde la firma del presente Contrato, durante su vigencia y hasta 3 (tres) años después de la
						terminación del mismo, el Comitente no podrá, por su propia cuenta, en nombre o por cuenta de, o en relación con alguna
						Persona, directa o indirectamente, bajo cualquier carácter, incluyendo pero no limitado a, empleador, empleado,
						funcionario, consejero, gerente, principal, agente, representante, parte en un contrato de coinversión, socio, accionista o
						cualquier otro titular de participaciones, contratista independiente, licenciante, licenciatario, franquiciador, franquiciado,
						distribuidor, consultor, asesor, promotor, proveedor, fideicomisario o mediante y a través de cualquier corporación,
						sociedad cooperativa, sociedad, empresa de responsabilidad limitada, fideicomiso, asociación irregular o de otra manera,
						continuar con, comprometerse a, tener interés financiero alguno o de otra índole en, o de alguna otra manera estar
						involucrado comercialmente en cualesquiera sociedades, actividades o negocios en todo o alguna parte del Territorio que
						sean substancialmente similares o iguales o que estén en competencia con Red Girasol.</span> <br><br>
                <ol class="text-justify" style="font-weight:bold">
                  <li class="dosdigitos" style="font-size:14px!important"><span style="font-weight:normal">
								Desde la firma del presente Contrato, durante su vigencia y hasta 3 (tres) años después de la terminación del
								mismo, el Comitente no podrá, por su propia cuenta, a nombre de, o en relación con alguna Persona, directa o
								indirectamente, bajo cualquier carácter, incluyendo pero no limitado a, como empleador, empleado, funcionario,
								consejero, gerente, principal, agente, representante, parte en un contrato de coinversión, socio, accionista u otro titular de
								participaciones, contratista independiente, licenciante, licenciatario, franquiciador, franquiciado, distribuidor, consultor,
								asesor, promotor, proveedor o fideicomisario o mediante y a través de cualquier corporación, sociedad cooperativa,
								sociedad, empresa de responsabilidad limitada, fideicomiso, asociación irregular o de otra manera: </span><br><br>
								<ol class="text-justify" style="font-weight:bold">
									<li class="tercernivel" style="font-size:14px!important"><span style="font-weight:normal">
										Contactar a o captar el negocio de (o procurar o asistir en el contacto o captación del negocio de)
										cualquier Inversionista o Proveedor para bienes y servicios similares o iguales a aquellos previamente
										ofrecidos por Red Girasol;
									</span></li><br>
									<li class="tercernivel" style="font-size:14px!important"><span style="font-weight:normal">
										Aceptar (o procurar o asistir en la aceptación de) cualquier negocio de cualquier Inversionista o Proveedor
										para bienes y servicios similares o iguales a aquellos ofrecidos en cualquier momento por Red Girasol; o
									</span></li><br>
									<li class="tercernivel" style="font-size:14px!important"><span style="font-weight:normal">
										Suministrar (o procurar o asistir en el suministro de) a cualquier Inversionista o Proveedor cualesquier
										bienes y servicios similares o iguales a aquellos previamente ofrecidos por Red Girasol.
									</span></li><br>
								</ol>
                  </li>
                  <li class="dosdigitos" style="font-size:14px!important"><span style="font-weight:normal">
								Desde la firma del presente Contrato, durante su vigencia y hasta 3 (tres) años después de la terminación del
								mismo, el Comitente no podrá, por su propia cuenta, a nombre de, o en relación con alguna Persona, directa o
								indirectamente, bajo cualquier carácter, incluyendo pero no limitado a, como empleador, empleado, funcionario,
								consejero, gerente, principal, agente, representante, parte en un contrato de coinversión, socio, accionista u otro titular de
								participaciones, contratista independiente, licenciante, licenciatario, franquiciador, franquiciado, distribuidor, consultor,
								asesor, promotor, proveedor o fideicomisario o mediante y a través de cualquier corporación, sociedad cooperativa,
								sociedad, empresa de responsabilidad limitada, fideicomiso, asociación irregular o de otra manera: </span><br><br>
								<ol class="text-justify" style="font-weight:bold">
									<li class="tercernivel" style="font-size:14px!important"><span style="font-weight:normal">
										Emplear, ofrecer empleo a, o solicitar el empleo o compromiso de, o de otra manera alentar a cualquier
										individuo que sea empleado por Red Girasol a terminar su relación laboral con los mismos, sin importar si
										dicho individuo pudiere incurrir en algún incumplimiento de su contrato o los términos del empleo al
										terminar el empleo con Red Girasol; o
									</span></li><br>
									<li class="tercernivel" style="font-size:14px!important"><span style="font-weight:normal">
										Procurar o asistir a cualquier Persona para emplear, ofrecer empleo a o solicitar el empleo o compromiso
										de, o de otra manera alentar a cualquier dicho individuo a terminar su relación laboral con Red Girasol
									</span></li><br>
								</ol>
                  </li>
                  <li style="font-size:14px!important"><span style="font-weight:normal">
								Desde la firma del presente Contrato, durante su vigencia y hasta 3 (tres) años después de la terminación del
								mismo, el Comitente no podrá, por su propia cuenta, a nombre de, o en relación con alguna Persona, directa o
								indirectamente, bajo cualquier carácter, incluyendo pero no limitado a, como empleador, empleado, funcionario,
								consejero, gerente, principal, agente, representante, parte en un contrato de coinversión, socio, accionista u otro titular de
								participaciones, contratista independiente, licenciante, licenciatario, franquiciador, franquiciado, distribuidor, consultor,
								asesor, promotor, proveedor o fideicomisario o mediante y a través de cualquier corporación, sociedad cooperativa,
								sociedad, empresa de responsabilidad limitada, fideicomiso, asociación irregular o de otra manera, interferir o intentar
								interferir con Red Girasol, como sociedad y en sus operaciones, o persuadir o intentar persuadir a cualquier Inversionista,
								Proveedor o empleado de Red Girasol para descontinuar o alterar la relación de dicha Persona con Red Girasol.
							</span></li><br>
                </ol>
              </li>

              <li class="dosdigitos" style="font-size:14px!important"><u>Impuestos.</u><span style="font-weight:normal">&nbsp;
						Todos y cada uno de los impuestos, contribuciones, derechos y obligaciones que deban pagarse con
						motivo de las operaciones derivadas de las obligaciones incluídas en el presente Contrato, correrán por cuenta de quien
						para tales efectos sea señalado como causante por las leyes fiscales aplicables.</span></li> <br>

              <li class="dosdigitos" style="font-size:14px!important"><u>Avisos y notificaciones.</u><span style="font-weight:normal">&nbsp;
						Todos los avisos, notificaciones, demandas y comunicaciones requeridas conforme a este
						Contrato deberán ser enviados por correo electrónico y por escrito y se considerará que se notificó debidamente si se
						entrega personalmente o se envía por correo certificado, correo registrado con el importe pre-pagado. Las Partes señalan
						como sus domicilios y direcciones convencionales para efectos de oír y recibir notificaciones, los siguientes:</span><br><br>

                Al Comisionista: <br><br>
                <span style="font-weight:normal">
						Red Girasol, S.A.P.I. de C.V.<br>
						Domicilio: Eugenio Garza Sada 3820 Int. 801, Colonia Mas Palomas, <br>
						Monterrey, Nuevo León México, C.P. 64780 <br>
						Tel: (81) 1107 0504<br>
						Correo: contacto@redgirasol.com<br>
						Atención: Mauricio de Mucha Treviño<br><br>
						</span>

                Al Comitente: <br><br>
                <span style="font-weight:normal">
						Nombre <br>
						Domicilio: <br>
						Tel:<br>
						Correo:<br>
						Atención:<br><br>

						Cualquier cambio o modificación de los domicilios aquí convenidos, deberá ser debidamente notificado por correo
						electrónico con acuse de recibo a la otra Parte para que surta efectos con por lo menos 10 (diez) días previos a la fecha en
						que pretenda la Parte notificante hacer cumplir dicho cambio de domicilio. De no cumplirse dicho requisito,
						la notificación hecha al último domicilio conocido surtirá efectos plenos. <br> <br>

						Asimismo, el Comitente deberá de notificar al Comisionista con todas las formalidades previstas en la presente Cláusula,
						cuando por cualquier motivo se viere obligado a cambiar los Sistemas de la ubicación en la que hubieren sido
						originalmente instalados, para lo cual el Comisionista deberá consentir dicho cambio y el Comitente deberá solicitar el
						cambio de ubicación de los Sistemas a los instaladores originales. <br> <br>
						</span>
              </li>

              <li class="dosdigitos" style="font-size:14px!important"><u>Cesión de Derechos.</u><span style="font-weight:normal">&nbsp;
						Las Partes no podrán ceder ni transferir los derechos y obligaciones adquiridos por virtud
						del presente Contrato, sin el consentimiento previo y por escrito del Comisionista. En caso contrario, aquella cesión o
						trasferencia de derechos y/u obligaciones sin el consentimiento de la otra Parte será nula.</span></li> <br>

              <li class="dosdigitos" style="font-size:14px!important"><u>Información Confidencial.</u><span style="font-weight:normal">&nbsp;
						Las Partes convienen en que cualquier información revelada o proporcionada por las
						Partes (cualquiera de sus filiales, sociedad controladora o subsidiarias), así como toda la información generada con
						relación al cumplimiento del objeto del presente Contrato, ya sea de manera escrita, verbal, electrónica, magnética o
						cualquier otra tecnología y demás información confidencial, o de cualquier otra índole, será considerada propiedad de
						dicha Parte. <br><br>

						Las Partes no revelarán a terceras Personas ninguna información propiedad de la otra Parte, debiendo utilizarla
						exclusivamente para el desarrollo del objeto de este instrumento. Una vez terminado este Contrato, las Partes deberán
						entregar en forma inmediata a la otra Parte toda la información y materiales que le hayan sido proporcionados.
					</span> <br> <br>

              <li class="dosdigitos" style="font-size:14px!important"><u>Acuerdo Único y modificaciones.</u><span style="font-weight:normal">&nbsp;
						Lo contenido en este Contrato constituye el acuerdo total entre las Partes
						respecto al objeto de este Contrato. Cualquier modificación o adición a los términos y condiciones del presente Contrato,
						Red Girasol le notificará mediante comunicado en el Sitio y/o mediante notificación enviada a la dirección de correo
						electrónico que se haya proporcionado, con 30 (treinta) días naturales de anticipación a la fecha que entren en vigor dichos
						cambios, entendiéndose que el Comitente otorga su consentimiento a dichas modificaciones o adiciones si no ejerce su
						derecho de dar por terminado el presente Contrato, manifestando su voluntad de terminar el presente Contrato en el plazo
						de 30 (treinta) días naturales siguientes al día en que se efectúe la notificación antes referida o si continúa realizando
						operaciones al amparo del mismo. <br><br>

						Adicionalmente, Red Girasol podrá enviar las notificaciones mencionadas en el párrafo anterior por correo y a través
						del Estado de Cuenta. Los avisos de modificaciones al Contrato contendrán, por lo menos: I. Denominación social y logotipo
						de Red Girasol; II. Domicilio y teléfono de contacto de Red Girasol, así como domicilio, teléfono y correo electrónico de
						la Unidad Especializada de Atención de Usuarios (“UNE”); III. Resumen de todas las modificaciones realizadas; IV.
						Fecha a partir de la cual entran en vigor, y V. Su derecho para dar por terminado el Contrato. Usted puede solicitar la
						terminación del Contrato dentro de los 30 (treinta) días posteriores al aviso sin responsabilidad alguna a su cargo, y bajo
						las condiciones pactadas originalmente, sin que Red Girasol pueda cobrarle penalización alguna por dicha causa ni cobrar
						cantidad adicional alguna con excepción de los adeudos que ya se hubiera generado a la fecha en que el Comitente solicite
						dar por terminado el Contrato. En el evento de que El Comitente no esté de acuerdo con las modificaciones realizadas,
						podrá solicitar la terminación del contrato dentro de los 30 (treinta) días posteriores al aviso señalado en el párrafo
						anterior, sin responsabilidad alguna a su cargo, y bajo las condiciones anteriores a la modificación, siempre y cuando el
						Comitente no tenga dinero en inversiones de Proyectos vigentes.
					</span></li> <br>

              <li class="dosdigitos" style="font-size:14px!important"><u>Gastos.</u><span style="font-weight:normal">&nbsp;
						La contraprestación aquí establecida, excluye todos los gastos y erogaciones relacionadas con las
						obligaciones del Comisionista conforme al presente Contrato, por lo tanto, el Comisionista podrá cobrar al Comitente
						cualquier otro gasto o erogación con la condición de que los mismos sean desglosados en su estado de cuenta mensual.
					</span></li> <br>

              <li class="dosdigitos" style="font-size:14px!important"><u>Caso fortuito y fuerza mayor.</u><span style="font-weight:normal">&nbsp;
						Las Partes no serán responsables por la falta de realización de las actividades
						establecidas en el presente Contrato, cuando existan causas fuera de su control incluyendo órdenes de cualesquiera
						autoridades gubernamentales, civiles y/o militares, huelgas, inundaciones, epidemias, guerras, disturbios y demás causas
						análogas de caso fortuito o fuerza mayor.
					</span></li> <br>

              <li class="dosdigitos" style="font-size:14px!important"><u>Ejercicio de Derechos.</u><span style="font-weight:normal">&nbsp;
						El hecho de que alguna de las Partes no ejerza alguno de sus derechos derivados del
						presente contrato, no significa, ni deberá ser considerado, como una renuncia o pérdida de tales derechos.
					</span></li> <br>

              <li class="dosdigitos" style="font-size:14px!important"><u>Correlación de documentos.</u><span style="font-weight:normal">&nbsp;
						Las PARTES no podrán alegar desconocimiento o inaplicabilidad de alguna de las
						normas que en cualquier documento se establezcan, por lo que cualquier incumplimiento de los mismos será un
						incumplimiento a los términos y condiciones pactados en este Contrato, así también no podrá alegarse por las Partes el
						desconocimiento de la terminología empleada en este Contrato, sus accesorios y demás instrumentos legales relacionados
						con este Contrato y con la relación jurídica que sostengan las Partes por diversos acuerdos.
					</span></li> <br>

              <li class="dosdigitos" style="font-size:14px!important"><u>Firma.</u><span style="font-weight:normal">&nbsp;
						Las Partes acuerdan que para la firma del presente Contrato podrán: (i) firmar autógrafamente, (ii) por
						medio de la Firma Electrónica Avanzada emitida por el Servicio de Administración Tributaria, y de conformidad con los
						artículos 2, 7, 8, 22 y demás aplicables de la Ley de Firma Electrónica Avanzada, (iii) por medio de la firma electrónica
						emitida por la Secretaría de Economía o (iv) mediante clic en el recuadro de ACEPTO junto con el ingreso de la
						contraseña respectiva. Cualquiera de los métodos previamente anunciados tendrá como efecto el sometimiento expreso a
						las disposiciones del presente y por lo tanto surtirán efectos plenos para las Partes, frente a ellos mismos y frente a
						terceros. Así mismo, el Comitente expresamente renuncia a argumentar desconocimiento de la firma del presente.</span></li> <br>

              <li class="dosdigitos" style="font-size:14px!important"><u>Definciones.</u><span style="font-weight:normal">&nbsp;
						Las Partes expresamente acuerdan que los términos definidos establecidos en el Apéndice 1 del
						presente y usados en el clausulado del presente contrato, tendrán el alcance y significado que en los mismos se establece y
						no su significado literal. Asimismo, las Partes convienen en utilizar dichos términos en los Anexos del presente contrato
						que al efecto se celebren.
					</span></li> <br>

              <li class="dosdigitos" style="font-size:14px!important"><u>Encabezados y Títulos de las cláusulas.</u><span style="font-weight:normal">&nbsp;
						Los encabezados y los títulos de las Cláusulas que aparecen en el
						presente Contrato, se han puesto con el exclusivo propósito de facilitar su lectura, por tanto, no necesariamente definen
						ni limitan el contenido de las mismas. Para efectos de interpretación de cada Cláusula deberá atenderse exclusivamente a su
						contenido y de ninguna manera a su título.
					</span> </li> <br>

              <li class="dosdigitos" style="font-size:14px!important"><u>Legislación  y jurisdicción aplicable.</u><span style="font-weight:normal">&nbsp;
						Las Partes se someten expresamente para la interpretación, cumplimiento y
						ejecución de este Contrato a lo establecido en el Código de Comercio, así como a la jurisdicción de los tribunales
						competentes de la ciudad de Monterrey, Nuevo León, México, respecto a cualquier acción o procedimiento, interpretación
						y cumplimiento de todo lo pactado en este Contrato, renunciando expresamente a cualquier jurisdicción que les pudiere
						corresponder en la actualidad o en el futuro por virtud de sus domicilios actuales o futuros o por cualquier otra razón.<br><br>

						El presente Contrato se firma de conformidad por las Partes que intervienen en el mismo, sin que mediare entre ellos vicio
                del consentimiento alguno, en la Ciudad de Monterrey, Nuevo León, el día ____________ del 20__. </span></li> <br> <br>
            </ol>

            <br>
            <div style="text-align: center"><strong><u>APÉNDICE 1</u></strong></div>
            <div style="text-align: center"><strong>Definciones</strong></div>
            <br>

            Para los efectos de este contrato, los siguientes términos tendrán el significado que a continuación se señalan: <br> <br>

            <ol class="text-justify" style="font-weight:bold">
              <li style="font-size:14px!important">"Comisión por Administración": <span style="font-weight:normal">
						Tiene el significado descrito en la cláusula 5.3 del presente Contrato.
					</span></li> <br>
              <li style="font-size:14px!important">"Comisión por Apertura": <span style="font-weight:normal">
						Tiene el significado descrito en la cláusula 5.1 del presente Contrato.
					</span></li> <br>
              <li style="font-size:14px!important">"Comisión por Fondeo": <span style="font-weight:normal">
						Tiene el significado descrito en la cláusula 5.2 del presente Contrato.
					</span></li> <br>
              <li style="font-size:14px!important">"Contrato": <span style="font-weight:normal">
						Significa el presente Contrato de Comisión, sus apéndices y anexos.
					</span></li> <br>
              <li style="font-size:14px!important">"Crédito": <span style="font-weight:normal">
						Significa el contrato de crédito a ser celebrado por y entre los Inversionistas, representados por Red
						Girasol, con el Comitente para la adquisición de los Productos.
					</span></li> <br>
              <li style="font-size:14px!important">"Documentos del Crédito": <span style="font-weight:normal">
						Significa (i) el Crédito, (ii) un contrato de prenda sobre los Productos entre los
						Inversionistas y el Comitente, (iii) un pagaré a ser firmado por el Comitente en favor de los Inversionistas; y (iv)
						un contrato de compraventa de bien inmueble por accesión entre el Comitente y el Proveedor.
					</span></li> <br>
              <li style="font-size:14px!important">"Enganche": <span style="font-weight:normal">
						Es la cantidad de $[*] (00/100 Moneda Nacional) que realiza el Comitente como pago adelantado
						contra la Factura.
					</span></li> <br>
              <li style="font-size:14px!important">"Factura": <span style="font-weight:normal">
						Es la cantidad de $[*] que corresponde a los Productos.
					</span></li> <br>
              <li style="font-size:14px!important">"Factura Restante": <span style="font-weight:normal">
						Significa la Factura menos el Enganche.
					</span></li> <br>
              <li style="font-size:14px!important">"Inversionistas": <span style="font-weight:normal">
						Es la o las personas físicas o morales que en conjunto financiarán al Comisionista para la
						adquisición de los Productos.
					</span></li> <br>
              <li style="font-size:14px!important">"Ley FinTech": <span style="font-weight:normal">
						Significa la Ley para Regular las Instituciones de Tecnología Financiera.
					</span></li> <br>
              <li style="font-size:14px!important">"Monto": <span style="font-weight:normal">
						Es la cantidad que los Inversionistas deberán financiar al Comitente equivalente a: (i) la Factura
						Restante, más la Comisión por Fondeo, más la Comisión por Apertura.
					</span></li> <br>
              <li style="font-size:14px!important">"Pago Inicial": <span style="font-weight:normal">
						Significa el Enganche más la Comisión por Apertura a ser pagado por el Comitente en favor del
						Comisionista.
					</span></li> <br>
              <li style="font-size:14px!important">"Parte": <span style="font-weight:normal">
						Lo constituyen el Comisionista o el Comitente en forma indistinta y separada, según corresponda.
					</span></li> <br>
              <li style="font-size:14px!important">"Partes": <span style="font-weight:normal">
						Lo constituyen el Comisionista y el Comitente en forma conjunta.
					</span></li> <br>
              <li style="font-size:14px!important">"Persona": <span style="font-weight:normal">
						Significa e incluye personas físicas, corporaciones, sociedades, sociedades en comandita simple,
						sociedades de responsabilidad limitada, empresas de responsabilidad limitada, sociedades generales, sociedades
						anónimas, coinversiones, asociaciones, empresas, fundaciones de intereses privados, fideicomisos, bancos,
						fiduciarios, fideicomisos inmobiliarios, fideicomisos comerciales u otras organizaciones, sean personas morales o
						no, y todas las Autoridades Gubernamentales.
					</span></li> <br>
              <li style="font-size:14px!important">"Productos": <span style="font-weight:normal">
						Son los activos propiedad del Proveedor, que el Comitente desea adquirir a través del Proyecto
						promovidos por el Comisionista con los Solicitantes.
					</span></li> <br>
              <li style="font-size:14px!important">"Proveedor": <span style="font-weight:normal">
						Es la persona física o moral que es propietario de los Productos que pretende vender al Comitente.
					</span></li> <br>
              <li style="font-size:14px!important">"Proyecto": <span style="font-weight:normal">
						Es el proyecto solicitado por el Solicitante para el financiamiento del Monto por Inversionistas para
						la adquisición de los Productos y el pago de comisiones en favor del Comisionista, formalizado a través de los
						Documentos del Crédito.
					</span></li> <br>
              <li class="dosdigitos" style="font-size:14px!important">"Red Girasol": <span style="font-weight:normal">
						Es la persona moral Red Girasol, S.A.P.I. de C.V.
					</span></li> <br>
              <li class="dosdigitos" style="font-size:14px!important">"Servicios": <span style="font-weight:normal">
						Serán todo tipo de actividades tendientes a conseguir financiamiento para la adquisición de los
						Productos del Proveedor, las cuales entre otras incluirán, la exhibición de la información del Comitente, la
						realización de todo tipo de actividades mediante las cuales se promueva la inversión para la adquisición de los
						Productos, incluyendo la entrega de todo tipo de información relativa a la transacción. Una vez que el Comitente
						opte por la adquisición de los Productos, el Comisionista deberá conseguir el Monto a financiarse con
						Inversionistas.</span></li> <br>
              <li class="dosdigitos" style="font-size:14px!important">"Sitio": <span style="font-weight:normal">
						Significa el dominio <a href="https://www.redgirasol.com/" style="color: blue"><u>https://www.redgirasol.com/</u></a>
						localizado en el Internet.
					</span></li> <br>
              <li class="dosdigitos" style="font-size:14px!important">"Territorio": <span style="font-weight:normal">
						Significa el territorio que comprenden los Estados Unidos Mexicanos.
					</span></li> <br>
            </ol>
          </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ApplicantMerchantContract"
}
</script>

<style scoped>

</style>